import { useAutoneTranslation } from '@autone/translations';
import { useMemo } from 'react';

import { useAdvancedFiltersInternalContext } from '../contexts/advanced-filters-internal.context';

interface AdvancedFiltersValueInputProps {
  rowId: string;
}

export const AdvancedFiltersValueInput = ({
  rowId,
}: AdvancedFiltersValueInputProps) => {
  const { common } = useAutoneTranslation();
  const { state, dispatch, config } = useAdvancedFiltersInternalContext();

  const { field, operator, value } = state.conditions[rowId];
  const { fieldConfigs } = config;
  const RenderInputComponent = useMemo(() => {
    if (!field) {
      return null;
    }

    const fieldConfig = fieldConfigs[field];
    return fieldConfig.renderInput;
  }, [field, fieldConfigs]);

  const isDisabled = !field || !RenderInputComponent;

  const handleUpdateValue = (value: unknown) => {
    dispatch({
      type: 'PATCH_CONDITION',
      payload: {
        rowId,
        condition: {
          value,
        },
      },
    });
  };

  if (isDisabled) {
    return (
      <input
        disabled={isDisabled}
        className="border-none outline-none h-full text-sm px-3 py-1 disabled:bg-white disabled:cursor-not-allowed"
        placeholder={common('advanced-filters.placeholders.enter-a-value')}
      />
    );
  } else {
    return (
      <RenderInputComponent
        value={value}
        onValueChange={handleUpdateValue}
        operator={operator}
      />
    );
  }
};
